<template>
  <section :class="$style.section">
    <div :class="$style.container">
      <h2 :class="$style.title">Наше предложение</h2>
      <div :class="$style.row">
        <div
          v-for="(item, index) in items"
          :key="index"
          :class="[$style.col, $style.offerCol]"
        >
          <svg
            v-svg
            :class="$style.offerIcon"
            :symbol="`icon-rounded-${item.icon}`"
          />
          <p :class="$style.offerTitle">{{ item.title }}</p>
          <p :class="$style.offerText">{{ item.text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TeamOffer',
  data() {
    return {
      items: [
        {
          icon: 'money',
          title: 'Достойная оплата труда',
          text:
            'Конкурентная зарплата с ежегодным пересмотром и индексацией. Оформление согласно законодательству. Система поощрения новых знаний.',
        },
        {
          icon: 'social',
          title: 'Коллектив профессионалов',
          text: 'Дружная международная команда и уважение личных приоритетов.',
        },
        {
          icon: 'grow',
          title: 'Динамичный рост',
          text:
            'Мы быстро развиваемся и постоянно открываем новые горизонты развития для каждого.',
        },
        {
          icon: 'chair',
          title: 'Комфортное рабочее место',
          text:
            'Наши уютные офисы расположены и оборудованы для максимального удобства наших сотрудников.',
        },
        {
          icon: 'batch',
          title: 'Очень Интересные задачи и проекты',
          text:
            'Мы там где нет других. Мы берем новые высоты каждый день и каждый член команды имеет непосредственное влияние на принятие решений.',
        },
        {
          icon: 'portfolio',
          title: 'Социальная жизнь',
          text:
            'Офисные мероприятия, участие в конференциях, путешествия между офисами.',
        },
      ],
    };
  },
};
</script>

<style lang="scss" module>
@import '../styles/variables';
@import '../styles/helpers';

.section {
  @extend %section;
}

.container {
  @extend %container;
  max-width: 1140px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -$grid-gutter;
  margin-right: -$grid-gutter;

  @include media('<=phone') {
    margin-left: -$grid-gutter-mobile;
    margin-right: -$grid-gutter-mobile;
  }
}

.title {
  @extend %sectionTitle;
  margin: 0 0 relative-mb(80, 46);
  text-align: center;

  @include media('<=phone') {
    margin-bottom: 30px;
  }
}

.offerCol {
  width: 33.33%;
  padding: $grid-gutter;
  text-align: center;
  display: grid;
  grid-template-rows: 80px 70px 1fr;
  justify-items: center;

  @include media('<=tablet') {
    width: 50%;
  }

  @include media('<=phone') {
    width: 100%;
    margin-bottom: 10px;
    padding: $grid-gutter-mobile;
  }
}

.offerCol:last-child {
  @include media('<=phone') {
    margin-bottom: 0;
  }
}

.offerIcon {
  width: 67px;
  height: 67px;
  margin-bottom: 14px;
  fill: $red-light;
}

.offerTitle {
  @include set-fz-lh(24, 30);
  color: $red;
  margin: 0;

  @include media('<=phone') {
    @include set-fz-lh(20, 30);
  }
}

.offerText {
  @include set-fz-lh(16, 25);
  color: $gray-dark;
  margin: 0;

  @include media('<=phone') {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TeamOffer.vue